var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanOfCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7549_31810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4655 6H15.3362V3C15.3362 1.9 14.4129 1 13.2845 1H11.2328C10.1043 1 9.18103 1.9 9.18103 3V6H4.05172C2.92328 6 2 6.9 2 8V19C2 20.1 2.92328 21 4.05172 21H20.4655C21.594 21 22.5172 20.1 22.5172 19V8C22.5172 6.9 21.594 6 20.4655 6ZM11.2328 3H13.2845V8H11.2328V3ZM20.4655 19H4.05172V8H9.18103C9.18103 9.1 10.1043 10 11.2328 10H13.2845C14.4129 10 15.3362 9.1 15.3362 8H20.4655V19ZM11.2328 15H9.18103V17H7.12931V15H5.07759V13H7.12931V11H9.18103V13H11.2328V15ZM13.2845 13.5V12H19.4397V13.5H13.2845ZM13.2845 16.5V15H17.3879V16.5H13.2845Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7549_31810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanOfCare);
export default __webpack_public_path__ + "static/media/PlanOfCare.2831da68.svg";
export { ForwardRef as ReactComponent };